import { useDblIntl } from '@/pages/datalab/utils/utils';
import { UseFormSearch } from '@gp/pages/Pipeline/ProjectDetails/components/GameOverviewEdit/Components/UseFormSearch';
import React, { useEffect, useRef } from 'react';
import { Button, Modal, notification } from 'tea-component';
import './index.scss';
import { useFromConfigMapKey, useSetAsTemplateData } from './hooks';
type TSetAsTemplateModalProps = {
  // 关闭方法
  onClose: () => void;
  // 非受控模态框开关
  visible: boolean;
  // 业务code
  gameCode: string;
  // 当前点击列表详情数据
  record: {[key in string]: unknown };
  refreshTabCountData?: (...args:any[])=>void;
};

const SetAsTemplateModal = (props: TSetAsTemplateModalProps) => {
  const { onClose, visible ,record, refreshTabCountData } = props;
  const { dblFormatMessage, commonFormatMessage } = useDblIntl('dashboard_list');
  const searchFormRef = useRef();
  const controllerRef = useRef();
  const { config } = useFromConfigMapKey({
    searchFormRef,
    key: 'setTemplateModal',
  });
  const { runAsync, loading } = useSetAsTemplateData({ signal: controllerRef.current?.signal});
  const getFormValue = async <V,>(value: V): Promise<void> => {
    try {
      await runAsync({...value, preview_image_url: record?.preview_image_url, id: record?.id, game_code: record?.game_code, show_contact: record?.show_contact});
      refreshTabCountData?.();
      notification.success({
        description: dblFormatMessage('template_set_success'),
      });
      onClose?.();
    } catch (error) {
      console.log(error);
    } 
  };
  useEffect(() => {
    if (visible) {
      controllerRef.current = new AbortController();
    } 
    return ()=>{
      controllerRef.current?.abort();
    };
  }, [visible]);
 
  const SearchComponent = UseFormSearch({
    config,
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    getFormValue,
    labelSpan: 6,
    reset: visible,
    isUnpack: false,
    initialValues: {
      category: 'game_template',
      template_title: record?.dashboard_title,
    },
    ref: searchFormRef,
    isShowSearchBtn: false,
    resetCallback: () => {
      controllerRef.current?.abort();
      onClose?.();
    },
  });
  return (
    <>
      <Modal
        visible={visible}
        onClose={onClose}
        caption={dblFormatMessage('set_template')}
      >
        <div className="dbl-dashboard-template-form-container">
          {SearchComponent}
          <Modal.Footer>
            <Button
              type="primary"
              loading={loading} 
              disabled={!searchFormRef?.current?.latestCountRef?.current?.valid}
              onClick={searchFormRef.current?.handleSubmit}
            >
              {commonFormatMessage('confirm')}
            </Button>
            <Button type="weak" onClick={searchFormRef.current?.onclose}>
              {commonFormatMessage('cancel')}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default SetAsTemplateModal;
